import { API_END_POINTS } from "../../constant/config";
import JsonInterceptor from "../../utils/JsonInterceptor";
import { GET_SETTING, UPDATE_SETTING } from "../type";

// Fetch Emails
export const fetchSettings = () => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.FETCH_SETTING;
        console.log(apiEndpoint)
        const response = await JsonInterceptor.get(`${apiEndpoint}`)
        dispatch({
            type: GET_SETTING,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};
// Fetch Emails
export const updateSettings = (id,data) => async (dispatch) => {
    try {
        const apiEndpoint = API_END_POINTS.UPDATE_SETTING;
        console.log(apiEndpoint)
        const response = await JsonInterceptor.put(`${apiEndpoint}/${id}`,data)
        dispatch({
            type: UPDATE_SETTING,
            payload: response.data.data,
        });
    } catch (error) {
        console.log("error", error);
    }
};


